import React from 'react'
import { Flex, Text, Button, Link, Box } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import styled, { keyframes } from 'styled-components'
import CompositeImage, { CompositeImageProps } from '../CompositeImage'
import PurpleWordHeading from '../PurpleWordHeading'


const ScrollBox = styled(Box)`
padding: 10px;
background: rgb(0,0,0);
border: 0.05px solid ${({ theme }) => theme.colors.gold};
width: 130px; 
border-radius: 5px;
margin-right: 10px; 
margin-top: 10px;
${({ theme }) => theme.mediaQueries.md} {
  background: rgb(0,0,0);
  border: 0.05px solid ${({ theme }) => theme.colors.gold};
  width: 130px; 
  margin-top: 10px;
  margin-right: 10px;
  padding: 10px;
  border-radius: 5px;  
}
`
const ImageWrapper = styled.div`
margin-top: 4px;
${({ theme }) => theme.mediaQueries.md} {
  margin-top: 4px;
 
}
`
interface SalesSectionButton {
  to: string
  text: string
  external: boolean
}

export interface SalesSectionProps {
  headingText: string
  bodyText: string
  reverse: boolean
  primaryButton: SalesSectionButton
  secondaryButton: SalesSectionButton
  images: CompositeImageProps
}

const SalesSection: React.FC<SalesSectionProps> = (props) => {
  const { t } = useTranslation()

  const { headingText, bodyText, reverse, primaryButton, secondaryButton, images } = props

  const headingTranslatedText = t(headingText)
  const bodyTranslatedText = t(bodyText)
 
  const ButtonText = styled(Text)`
  display: none;
  ${({ theme }) => theme.mediaQueries.xs} {
    display: block;
  }
`
  return (
    <Flex flexDirection="column"     alignItems="center"
    >
      <Flex
        alignItems="center"
        justifyContent="center"
      >
        <Flex
          flexDirection="column" 
          alignItems="center"
          >
             
          <Text color="gold" mb="5px" fontSize="30px" bold textAlign="center">
          {t('Join Our Community')}
          </Text>
          <Text color="text" fontSize="18px" textAlign="center">
          {t('Extremely active community that loves our mission and doges! Our telegram and discord is filled with community members that would love to help you. Do not trust random messages of people claiming to be “support” or ever give out your wallet info to anyone.')}
          </Text>
          <Flex>
            
          <Flex
          flexDirection="column" 
          alignItems="center"
          mt="10px" 
          >
  
            <ScrollBox>
                            <Flex    justifyContent="center"  alignItems="center">
                           
            <Link external={primaryButton.external} href="https://twitter.com/HunVizslainu">
            <Text color="text" mr="5px" fontSize="20px" bold textAlign="center">
          {t('+27,000')}
          </Text>
          <ImageWrapper>
        <img src="/images/274.png" alt="ifo bunny" width="25px" height="25px"/>
      </ImageWrapper>
            </Link>
            </Flex>
            </ScrollBox>
            </Flex>

            <Flex 
          flexDirection="column" 
          alignItems="center"
          mt="10px" 
          >
                              <ScrollBox>

<Flex    justifyContent="center"  alignItems="center">
<Link  external={primaryButton.external} href="https://t.me/hungarianvizslainucoin">
<Text color="text" mr="5px" fontSize="20px" bold textAlign="center">
{t('+3,500')}
</Text>
<ImageWrapper>
<img src="/images/275.png" alt="ifo bunny" width="25px" height="25px"/>
</ImageWrapper>
</Link>
</Flex> 
</ScrollBox> 

            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default SalesSection
